import React from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { Bar } from 'react-chartjs-2';
import { chartHelper } from '../helpers';
import _ from "lodash";


export default class ChartEquipmentStatus extends React.Component {
  displayName = 'Equipment by Status';
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      currentSetIndex: 0,
      currentDataSet: {
        datasets: [],
        labels: [
          "Active", 
          "Out of Service",
          "Stored",
          "Inactive"
        ]
      },
      title: ""
    };
    this.changeDataSet = this.changeDataSet.bind(this);
    this.startIntervalTimer = this.startIntervalTimer.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.data && this.props.data.length > 0 && !_.isEqual(prevProps.data, this.props.data)) {
      this.setState({ data: this.props.data}, () => {
        this.startIntervalTimer();
      })
    }
  }

  componentWillUnmount() {
    clearInterval();
  }

  changeDataSet() {
    const {
      currentSetIndex,
      data
    } = this.state;
    const isLastItem = (data.length - 1) === currentSetIndex
    const nextIndex = isLastItem ? 0 : currentSetIndex + 1;
    this.setState({
      currentSetIndex: nextIndex,
      currentDataSet: data[nextIndex].data,
      title: data[nextIndex].title
    });
  }

  startIntervalTimer() {
    var _this = this;

    setInterval(function(){
      _this.changeDataSet()
    }, 10000);
  }

  render() {
    const {
      currentDataSet
    } = this.state;
    const options = chartHelper.chartOptions();
    const chartReady = currentDataSet && currentDataSet.datasets.length > 0;
    const totalLength =
      chartReady && currentDataSet.datasets[0].data && currentDataSet.datasets[0].data.length > 0 
        ? _.sum(currentDataSet.datasets[0].data) : 0;
    return (
      <Card className="mb-2">
        <CardHeader className="homeCards">
          <h5>{this.displayName} - {this.props.totalEquipment} Total</h5>
        </CardHeader>
        <CardBody className="pt-1">
          <div className="py-0 mt-0">
            <Row className="expand-md">
              <Col className="text-center">
                <h5><i>Type: {this.state.title} ({totalLength})</i></h5>
              </Col>
            </Row>
            <Bar
              data={currentDataSet}
              width={200}
              height={300}
              options={options}
            />
          </div>
        </CardBody>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartEquipmentStatus.js